import { isDefined } from "@clipboard-health/util-ts";
import { useCurrentDate } from "@src/appV2/lib/utils/useCurrentDate";
import { useGeofenceContext } from "@src/appV2/Location/geofence/useGeofence";
import { useWorkerEtaImprovementsConfig } from "@src/appV2/redesign/ClipboardScore/hooks/useWorkerEtaImprovementsConfig";
import { UPDATE_ETA_BOTTOM_SHEET_SOURCE } from "@src/appV2/redesign/Shift/WorkerEta/UpdateEta/types";
import { useGetWorkerTrips } from "@src/appV2/redesign/Shift/WorkerEta/useGetWorkerTrips";
import { type Shift } from "@src/appV2/Shifts/Shift/types";
import { parseISO } from "date-fns";
import { generatePath, useHistory } from "react-router-dom";

import { SHIFT_DETAILS_UPDATE_ETA_FULL_PATH } from "../../../path";
import { isWithinEtaUpdateWindow } from "./isWithinEtaUpdateWindow";
import { UpdateEtaCard } from "./UpdateEtaCard";

interface WorkerShiftDetailsUpdateEtaCardContainerProps {
  shift: Shift;
}

export function WorkerShiftDetailsUpdateEtaCardContainer(
  props: WorkerShiftDetailsUpdateEtaCardContainerProps
) {
  const { shift } = props;
  const now = useCurrentDate(1000);
  const history = useHistory();

  const {
    enabled: isWorkerEtaUpdateEnabled,
    shiftLeadTimeToUpdateEtaMinutes,
    maxMinutesAheadToUpdateEta,
  } = useWorkerEtaImprovementsConfig();
  const { inside } = useGeofenceContext();

  const shouldShowUpdateEtaCard =
    isWorkerEtaUpdateEnabled &&
    !inside &&
    !isDefined(shift.clockInOut?.start) &&
    isWithinEtaUpdateWindow({
      now,
      shiftStart: parseISO(shift.start),
      windowMinutesBefore: shiftLeadTimeToUpdateEtaMinutes,
      windowMinutesAfter: maxMinutesAheadToUpdateEta,
    });

  const { data: workerTrips } = useGetWorkerTrips(
    {
      shiftId: shift._id,
    },
    { enabled: shouldShowUpdateEtaCard }
  );

  if (!shouldShowUpdateEtaCard) {
    return null;
  }

  const workerDeclaredEta = workerTrips?.[0]?.attributes.workerDeclaredEta;
  const updatedEta = workerDeclaredEta ? parseISO(workerDeclaredEta) : undefined;

  return (
    <UpdateEtaCard
      updatedEta={updatedEta}
      workplaceTimezone={shift.facility.tmz ?? "America/Los_Angeles"}
      onUpdateEta={() => {
        history.replace(
          generatePath(
            `${SHIFT_DETAILS_UPDATE_ETA_FULL_PATH}?source=${UPDATE_ETA_BOTTOM_SHEET_SOURCE.SHIFT_DETAILS}`,
            {
              shiftId: shift._id,
            }
          )
        );
      }}
    />
  );
}
